module.exports = __webpack_public_path__ + "static/media/classification18.f9029a37.jpg";